module.exports = __webpack_public_path__ + "img/9788925871639.987466d8.jpg";